import "./vendorSignup.css";
// import { Button } from "react-bootstrap";
// import NavLink from "react-bootstrap";

// https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete for accessibility, google loves a11y for ranking.

const VendorRequestForm = () => {

  // const handleClick = () => {
  //   window.location.href = "https://www.simpletix.com/e/vendor-request-tickets-197701";
  // };
  
  return (
    <section id="rsvp">
      <div className="rsvp-container">
        <div className="rsvp-content">
          <h2 className="rsvp-title">
            Vendor Applicatons
          </h2>
        </div>
        <div className="disclaimer">
        VENDOR APPLICATIONS TO BEGIN SOON
          <br />
        </div>
      </div>

      <div>
        <div className="vendor-desc" style={{ textAlign: "center", padding: "20px", color:"#e5dece" }}>
          <p>To apply, please email BFC2024INFO@GMAIL.COM. Provide your group name and product information as well as a choice of the following:</p>
          <ul>
            <li>$125 each for inside - each space includes 1 6 foot table and 2 chairs.</li>
            <li>$100 each for outside - each space includes 1 6 foot table and 2 chairs; Vendor will provide own awning (electric not available)</li>
            <li>Number of spaces needed</li>
          </ul>
          Once the above information is received, confirmation will be sent to you with a link for payment as well as the vendor agreement. If you have any questions, please email the above address.
        </div>
      </div>

      {/* <div className="vendor-link-btn">
        <button onClick={handleClick}>
          Go to Vendor Request
        </button>
      </div> */}
    </section>
  );
};

export default VendorRequestForm;
